import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import moment from 'moment';
import { forkJoin } from 'rxjs';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { ReportService } from 'src/app/services/report.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-dispatch-report',
    templateUrl: './dispatch-report.component.html',
    styleUrls: ['./dispatch-report.component.scss']
})
export class DispatchReportComponent implements OnInit {


    dispatchReportForm: FormGroup;
    toMinDate: Date;
    toMaxDate: Date;
    @ViewChild('startDate') startDateDatePicker: MatDatepicker<Date>;
    @ViewChild('endDate') endDateDatePicker: MatDatepicker<Date>;
    orderStatusList: any = []
    filteredList1: any = []
    serviceQueue: any = []
    diapatchTimeTypeList: any;

    constructor(
        private fb: FormBuilder,
        private reportService: ReportService,
        private lookupDataService: LookupDataServiceService
    ) {
    }


    ngOnInit(): void {
        this.init()
        this.loadServiceQueue()
        this.executeServiceQueue()
    }
    init() {
        this.dispatchReportForm = this.fb.group({
            startDate: [null, Validators.required],
            endDate: [null, Validators.required],
            dispatchTimeId: [null],
        });
    }
    Reset() {
        this.dispatchReportForm.reset()
    }
    openStartDateDatePicker() {
        this.startDateDatePicker.open();
    }

    openEndDateDatePicker() {
        this.endDateDatePicker.open();
        this.toMinDate = this.dispatchReportForm.controls["startDate"].value;
        const maxDate = new Date(this.toMinDate);
        maxDate.setMonth(maxDate.getMonth() + 1);
        this.toMaxDate = maxDate;
        const today=new Date()
        if(this.toMaxDate>today)
            this.toMaxDate=today
    }
    loadServiceQueue() {
        this.serviceQueue.push(this.lookupDataService.getDispatchTime());
    }
    executeServiceQueue() {
        forkJoin(this.serviceQueue).subscribe((serviceResponse) => {
            debugger
            this.diapatchTimeTypeList = serviceResponse[0];
            this.diapatchTimeTypeList = this.diapatchTimeTypeList.sort((a, b) => a.value.localeCompare(b.value));
            this.filteredList1 = this.diapatchTimeTypeList.slice()
        });
    }


    generateExcel() {
        debugger
        if (!this.dispatchReportForm.value.startDate && !this.dispatchReportForm.value.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'From date and To date should not be empty',
                position: 'center',

            })
        }
        else if (!this.dispatchReportForm.value.startDate) {
            Swal.fire({
                icon: 'warning',
                title: 'From date should not be empty',
                position: 'center',

            })
        }
        else if (!this.dispatchReportForm.value.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'End date should not be empty',
                position: 'center',

            })
        }
        else if (this.dispatchReportForm.value.startDate > this.dispatchReportForm.value.endDate) {
            if (this.dispatchReportForm.value.endDate) {
                Swal.fire({
                    icon: 'warning',
                    title: 'End Date should be greater than Start Date',
                    position: 'center',
                })
            }
        }
        else {
            debugger
            var filterSearch: any = {};
            var start = moment(this.dispatchReportForm.value.startDate).format("YYYY/MM/DD");
            var end = moment(this.dispatchReportForm.value.endDate).format("YYYY/MM/DD");

            filterSearch = { startDate: start, endDate: end, dispatchTimeId: this.dispatchReportForm.value.dispatchTimeId };

            this.reportService.getDispatchReportPDF(filterSearch).subscribe((data) => {
                if (data) {
                    const linkSource = 'data:application/pdf;base64, ' + data;
                    const downloadLink = document.createElement('a');
                    const fileName = 'DispatchReport.pdf';
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();

                }
            });
        }
    }


}



